import React, { useEffect, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import "./CriarAcao.css";

function CriarAcao() {
    const { leadId } = useParams(); // Pegando o lead_id da URL
    const location = useLocation(); // Pegando os dados passados via state
    
    const navigate = useNavigate();

    // Pegando os dados do lead passados via state (caso existam)
    const leadData = location.state?.lead;

    const [formData, setFormData] = useState({
        lead_id: leadId || leadData?.id || "",
        descricao: "",
        data_acao: "",
        objecao: "",
    });

    const [leads, setLeads] = useState([]);
    const [filteredLeads, setFilteredLeads] = useState([]);
    const [searchTerm, setSearchTerm] = useState(leadData?.nome || ""); // Preenche o nome do lead
    const [showSuggestions, setShowSuggestions] = useState(false);
    const [message, setMessage] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const [leadInfo, setLeadInfo] = useState(null);



    useEffect(() => {
        if (!leadData && leadId) {
            fetchLeadById(leadId);
        }
    }, [leadId, leadData]);

    // Função para buscar detalhes do lead pelo ID (caso necessário)
    const fetchLeadById = async (id) => {
        try {
            console.log("🔍 Buscando lead pelo ID:", id);
            const response = await fetch(`https://welaunchyou.com.br/crm-wly/listagem_leads.php?lead_id=${id}`, {
                credentials: "include",
            });

            const data = await response.json();
            console.log("✅ Dados do lead recebido:", data);

            if (data.lead) {
                setSearchTerm(data.lead.nome);
                setFormData((prev) => ({ ...prev, lead_id: data.lead.id }));
            } else {
                console.error("⚠️ Lead não encontrado:", data);
                setLeadInfo(null);
            }
        } catch (err) {
            console.error("❌ Erro ao buscar lead pelo ID:", err);
            setLeadInfo(null);
        }
    };

    useEffect(() => {
        fetchLeads();
    }, []);

    const fetchLeads = async () => {
        try {
            console.log("🔄 Buscando leads...");
            const response = await fetch("https://welaunchyou.com.br/crm-wly/listagem_leads.php", {
                credentials: "include",
            });

            const data = await response.json();
            console.log("✅ Leads recebidos:", data);

            if (data.leads) {
                setLeads(data.leads);
            } else {
                console.error("⚠️ Formato inesperado:", data);
                setLeads([]);
            }
        } catch (err) {
            console.error("❌ Erro ao buscar leads:", err);
        }
    };

    const handleSearch = (e) => {
        const value = e.target.value;
        setSearchTerm(value);

        console.log("🔍 Usuário digitou:", value);

        if (value.length >= 2) {
            const results = leads.filter((lead) =>
                lead.nome.toLowerCase().includes(value.toLowerCase())
            );

            console.log("📋 Resultados filtrados:", results);
            setFilteredLeads(results);
            setShowSuggestions(results.length > 0);
        } else {
            console.log("❌ Menos de 2 caracteres digitados, escondendo sugestões");
            setFilteredLeads([]);
            setShowSuggestions(false);
        }
    };

    const handleSelectLead = (lead) => {
        console.log("✅ Lead selecionado:", lead);
        setFormData({ ...formData, lead_id: lead.id });
        setSearchTerm(lead.nome);
        setFilteredLeads([]);
        setShowSuggestions(false);
    };

    const handleBlur = () => {
        setTimeout(() => setShowSuggestions(false), 200);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        console.log(`✏️ Campo atualizado: ${name} -> ${value}`);
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setMessage("");
        setError("");

        console.log("🚀 Enviando formulário com dados:", formData);

        if (!formData.lead_id || !formData.descricao || !formData.data_acao) {
            setError("Por favor, preencha todos os campos obrigatórios.");
            setLoading(false);
            return;
        }

        try {
            const response = await fetch("https://welaunchyou.com.br/crm-wly/criar_acao.php", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                credentials: "include",
                body: JSON.stringify(formData),
            });

            const data = await response.json();
            console.log("📩 Resposta do servidor:", data);

            if (response.ok) {
                setMessage("Ação criada com sucesso!");
                setTimeout(() => navigate("/acoes"), 2000);
            } else {
                setError(data.error || "Erro ao criar ação.");
            }
        } catch (err) {
            console.error("❌ Erro ao se conectar ao servidor:", err);
            setError("Erro ao se conectar ao servidor.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="acoes-container">
            <h1>Criar Ação</h1>
            <div className="criar-acao-container">
                {message && <p className="success-message">{message}</p>}
                {error && <p className="error-message">{error}</p>}

                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label htmlFor="lead_search">Lead:</label>
                        <input
                            type="text"
                            id="lead_search"
                            value={searchTerm}
                            onChange={handleSearch}
                            placeholder="Digite o nome do lead..."
                            autoComplete="off"
                            onFocus={() => setShowSuggestions(searchTerm.length >= 2)}
                            onBlur={handleBlur}
                            disabled={!!leadId} // Impede edição se o lead já estiver definido
                        />
                        {showSuggestions && filteredLeads.length > 0 && (
                            <div className="suggestions">
                                {filteredLeads.map((lead) => (
                                    <div
                                        key={lead.id}
                                        className="suggestion"
                                        onMouseDown={() => handleSelectLead(lead)}
                                    >
                                        {lead.nome}
                                    </div>
                                ))}
                            </div>
                        )}
                        <input type="hidden" name="lead_id" value={formData.lead_id} required />
                    </div>

                    <div className="form-group">
                        <label htmlFor="descricao">Descrição:</label>
                        <textarea
                            id="descricao"
                            name="descricao"
                            value={formData.descricao}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="data_acao">Data da Ação:</label>
                        <input
                            type="date"
                            id="data_acao"
                            name="data_acao"
                            className="input-data-acao"
                            value={formData.data_acao}
                            onChange={handleChange}
                            required
                        />    
                    </div>

                    <button className="btn-user" type="submit" disabled={loading}>{loading ? "Criando..." : "Criar"}</button>
                </form>
            </div>
        </div>
    );
}

export default CriarAcao;
